import React from "react";
import config from '@/config';

export const cleanUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;
  return url.trim().replace(/^"|"$/g, '') || undefined;
};

// Get K12zone Url as per role
export const getK12ZoneUrl = (
  userRole: string | undefined,
  st_k12zoneUrl?: string
): string | undefined => {
  const isStudent = userRole === 'STUDENT';
  // ST role
  if (isStudent && st_k12zoneUrl) {
    return cleanUrl(st_k12zoneUrl);
  }
  // LC role
  const lcUrl = config.LINKS.K12Zone_URL;
  return cleanUrl(lcUrl);
};

// Get External Urls Values
export const getCommunityUrl = (): string | undefined => {
  const url = config.LINKS.COMMUNITY_URL;
  if (!url) console.warn('COMMUNITY_URL not set in variables.');
  return url?.trim().replace(/^"|"$/g, '');
};

// Quicklink - Launch Chat URL
export const getChatUrl = (identityId: string): string => {
  const baseChatUrl = import.meta.env.VITE_K12_CHAT_URL;
  if (!baseChatUrl) {
    console.warn("Chat URL base is missing in VITE_K12_CHAT_URL");
    return "";
  }
  // Replace placeholder of VITE_K12_CHAT_URL with correct identityId
  return baseChatUrl.replace("{k12_onboarding_identity_id}", identityId);
}; 
export const openChat = (identityId: string | null | undefined): void => {
  if (!identityId) {
    console.warn("Identity ID missing, cannot open chat.");
    return;
  }
  const chatUrl = getChatUrl(identityId);
  if (chatUrl && chatUrl !== "#") {
    window.open(chatUrl, "_blank");
  }
};

// To get Canvas Portal URL (API)
export const openCanvasPortal = (canvasLink: string | undefined | null): void => {
  try {
    if (!canvasLink) {
      console.warn("Canvas link is missing from API.");
      return;
    }
    const cleanUrl = canvasLink.trim().replace(/^"|"$/g, "");
    window.open(cleanUrl, "_blank");
  } catch (error) {
    console.error("Failed to open Canvas Portal:", error);
  }
};
/**
 * Normalizes the Canvas quicklink API value. Placeholders mean OLS is not ready;
 * consumers should show a disabled control rather than treating them as URLs.
 */
export const normalizeCanvasLink = (raw: string | null | undefined): string | null => {
  if (raw == null) return null;
  const trimmed = raw.trim().replace(/^"|"$/g, '');
  if (!trimmed || trimmed === 'NO_OLS_LINK') return null;
  return trimmed;
};

export const shouldShowOLSLink = (linkUrl?: string): boolean => {
  const u = linkUrl?.trim();
  if (!u || u === 'NO_OLS_LINK') return false;
  return true;
};

// Logout handler
export const handleLogout = async (
  oktaAuth: any,
  postLogoutRedirectUri: string
): Promise<void> => {
  try {
    await oktaAuth.signOut({ postLogoutRedirectUri });
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("canvas");
    sessionStorage.removeItem("hasRedirected");
  } catch (error) {
    console.error("Logout failed", error);
  }
};

// Quicklinks Account URL (API)
export const openAccountLink = (url?: string | null) => {
  try {
    const cleanedUrl = cleanUrl(url);
    if (!cleanedUrl) {
      console.warn("My Account link is missing.");
      return;
    }
    window.open(cleanedUrl, "_blank");
  } catch (error) {
    console.error("Failed to open My Account link:", error);
  }
};

// OLS/Calender Hyperlink Conditional
export const renderConditionalLink = (
  text: string,
  href?: string,
  className?: string,
  style?: React.CSSProperties
): React.ReactNode => {
  if (href && href.trim() !== "") {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        style={style}
      >
        {text}
      </a>
    );
  }
  return <span className={className} style={style}>{text}</span>;
};
